import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="py-10 md:py-14 text-center">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                关于我们
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                国产精品一区——精选优质国产原创内容聚合平台，致力于为用户提供最优质的国产内容体验
              </p>
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-16">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4 border-l-4 border-primary-400 pl-4">
                  品牌故事
                </h2>
                <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
                  <p>
                    国产精品一区创立于2023年，由一群热爱国产原创内容的创作者共同发起。我们深知，在信息爆炸的时代，优质内容的发现和获取变得越来越困难。因此，我们致力于打造一个专注于<strong>国产原创精品内容</strong>的聚合平台，帮助用户高效地发现、阅读和分享优质内容。
                  </p>
                  <p>
                    我们的团队由资深的编辑、技术专家和内容创作者组成，秉持"<strong>严选精品、持续更新、专业分类</strong>"的核心理念，为每一位用户提供流畅、高清、稳定的在线体验。
                  </p>
                  <p>
                    无论您是在寻找最新的<strong>国产电影评论</strong>、优质的<strong>华语文学作品</strong>、深度的<strong>科技资讯</strong>，还是精致的<strong>生活美学指南</strong>，国产精品一区都将是您最值得信赖的内容伙伴。
                  </p>
                </div>
              </div>
              <div className="relative w-full h-72 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20creative%20office%20workspace%20with%20warm%20lighting%2C%20team%20collaboration%2C%20content%20creation%20environment%2C%20elegant%20minimalist%20design%2C%20cultural%20aesthetic%2C%20professional%20photography&width=800&height=600&seq=about-brand-story&orientation=landscape"
                  alt="国产精品一区团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    name: '李明',
                    role: '影视爱好者',
                    content: '国产精品一区的影视分类做得特别好，文章质量非常高，现在已经成为我每天必看的内容平台了。',
                    rating: 5,
                  },
                  {
                    name: '王雪',
                    role: '文学编辑',
                    content: '作为一个文学从业者，我很欣赏这个平台对原创文学的尊重和推广。内容筛选非常用心，推荐算法也很精准。',
                    rating: 5,
                  },
                  {
                    name: '张伟',
                    role: '科技创业者',
                    content: '科技板块的内容深度和前沿性让我印象深刻。每篇文章都有独到的见解，不是简单的资讯搬运。',
                    rating: 5,
                  },
                  {
                    name: '陈静',
                    role: '设计师',
                    content: '生活美学分类下的内容给了我很多设计灵感。图文并茂，排版也很舒适，阅读体验非常棒。',
                    rating: 4,
                  },
                  {
                    name: '刘洋',
                    role: '历史爱好者',
                    content: '历史人文板块的文章兼具学术性和可读性，既能学到知识又不会觉得枯燥。强烈推荐给所有历史文化爱好者。',
                    rating: 5,
                  },
                  {
                    name: '赵敏',
                    role: '音乐教师',
                    content: '音乐鉴赏类的深度乐评让我对中国原创音乐有了全新的认识。平台的内容质量一直在提升，值得长期关注。',
                    rating: 5,
                  },
                ].map((review, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-lg bg-background-50 border border-background-200/70"
                  >
                    <div className="flex gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${
                            i < review.rating
                              ? 'ri-star-fill text-primary-400'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{review.content}"
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                        <span className="text-sm font-semibold text-accent-600">
                          {review.name[0]}
                        </span>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-950">{review.name}</div>
                        <div className="text-xs text-foreground-500">{review.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                常见问题
              </h2>
              <div className="space-y-4 max-w-3xl mx-auto">
                {[
                  {
                    q: '国产精品一区平台的主要内容来源是什么？',
                    a: '我们的内容来自精选的国产原创作者和优质内容机构。所有上线内容均经过专业编辑团队严格审核，确保内容的原创性、品质和价值。',
                  },
                  {
                    q: '平台的内容更新频率如何？',
                    a: '国产精品一区保持每日更新，六大分类每周至少更新3-5篇精品内容。我们也会根据热点事件和用户需求，适时推出专题内容合集。',
                  },
                  {
                    q: '如何成为平台的原创作者？',
                    a: '您可以通过我们的官方邮箱提交创作申请和代表作品。我们的编辑团队会在5个工作日内进行审核，审核通过后将与您联系签约事宜。',
                  },
                  {
                    q: '平台的会员服务有哪些权益？',
                    a: '基础内容浏览完全免费。我们的高级会员可以享受无广告阅读、专属内容推荐、离线下载和优先参加线上线下活动等增值服务。',
                  },
                  {
                    q: '如何联系客服获取帮助？',
                    a: '您可以通过页面底部的联系方式，或发送邮件至contact@guochanyiqu.com，我们的客服团队将在24小时内回复您的问题。',
                  },
                ].map((faq, index) => (
                  <details
                    key={index}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 font-heading text-base font-semibold text-foreground-950 list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 p-8 rounded-lg bg-background-100 border border-background-200/70">
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  电子邮箱
                </h3>
                <p className="text-sm text-foreground-600">contact@guochanyiqu.com</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-phone-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  客服热线
                </h3>
                <p className="text-sm text-foreground-600">400-000-0000</p>
                <p className="text-xs text-foreground-500 mt-1">周一至周五 9:00-18:00</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-200">
                  <i className="ri-map-pin-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  公司地址
                </h3>
                <p className="text-sm text-foreground-600">中国北京市朝阳区</p>
                <p className="text-sm text-foreground-600">建国路88号SOHO现代城</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 国产精品一区',
            description: '国产精品一区——精选优质国产原创内容聚合平台，致力于为用户提供最优质的国产内容体验',
            url: 'https://www.guochanyiqu.com/about',
            publisher: {
              '@type': 'Organization',
              name: '国产精品一区',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '国产精品一区平台的主要内容来源是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的内容来自精选的国产原创作者和优质内容机构。所有上线内容均经过专业编辑团队严格审核，确保内容的原创性、品质和价值。',
                },
              },
              {
                '@type': 'Question',
                name: '平台的内容更新频率如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '国产精品一区保持每日更新，六大分类每周至少更新3-5篇精品内容。我们也会根据热点事件和用户需求，适时推出专题内容合集。',
                },
              },
              {
                '@type': 'Question',
                name: '如何成为平台的原创作者？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过我们的官方邮箱提交创作申请和代表作品。我们的编辑团队会在5个工作日内进行审核，审核通过后将与您联系签约事宜。',
                },
              },
              {
                '@type': 'Question',
                name: '平台的会员服务有哪些权益？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '基础内容浏览完全免费。我们的高级会员可以享受无广告阅读、专属内容推荐、离线下载和优先参加线上线下活动等增值服务。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系客服获取帮助？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过页面底部的联系方式，或发送邮件至contact@guochanyiqu.com，我们的客服团队将在24小时内回复您的问题。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}